import { useState } from "react";
// Libraries
import { useHistory, Redirect, useParams } from "react-router-dom";
// Utils
import { BATCH_VIEW, GROUPS } from "constants/Routes";
import { ELEMENTS_IDS } from "constants/ElementsIds";
// Hooks
import { useStateSpecies } from "hooks";
// Components
import { Button, Breadcrumbs, LoadingOverlay, Header, PageContent, PageHeader, Spacer } from "components";
// Resources
import { BatchInfoBlock } from "components/MyLivestock/Groups/BatchInfoBlock";
import AssignAnimalsToGroup from "../AssignAnimalsToGroup";
import { useGetBatchById } from "hooks/useGetBatchById";

export const BatchView = () => {
  const { active: speciesActive } = useStateSpecies();
  const { groupId } = useParams<LivestockGroupPageParams>();
  const history = useHistory();
  const [isEdited, changeEditMode] = useState<string | null>(null);

  const { data: batch, loading: getBatchLoading, error } = useGetBatchById(groupId);

  if (error) return <Redirect to={GROUPS} />;

  if (!batch || !batch.isBatch) {
    if (getBatchLoading) return <LoadingOverlay />;

    return <Redirect to={GROUPS} />;
  }

  if (speciesActive) {
    const isGroupDifferentSpecies = batch.animalType?.id !== speciesActive.id;
    if (isGroupDifferentSpecies) return <Redirect to={GROUPS} />;
  }
  return (
    <>
      <PageHeader>
        <Breadcrumbs
          rootPaths={[
            {
              path: "Groups",
              route: GROUPS,
            },
          ]}
          currentPath="Group Information"
        />
        <Header backButton title={batch.name || ""} />
        <BatchInfoBlock batch={batch}>
          <Spacer baselineHeight={3} />
          <Button
            id={ELEMENTS_IDS.EDIT_GROUP_BUTTON}
            caption="Edit"
            onClick={(): void => history.push(`${BATCH_VIEW}/edit/${batch.id}`)}
          />
        </BatchInfoBlock>

        <Spacer baselineHeight={3} />
      </PageHeader>

      <PageContent>
        <Spacer baselineHeight={3} />
        <AssignAnimalsToGroup isBatch isEdited={isEdited} changeEditMode={changeEditMode} />
      </PageContent>
    </>
  );
};
